"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = void 0;

var Interfaces_1 = require("../Interfaces");

var Config =
/** @class */
function () {
  function Config() {}

  Config.getBasePaymentUrl = function (env) {
    switch (env) {
      case Interfaces_1.Env.prod:
        return "https://ue1.public.payments.fast.asurion.com/v1";

      case Interfaces_1.Env.qa:
        return "https://ue1.public.payments.npr.fast.asurion.com/qa";

      case Interfaces_1.Env.dev:
        return "https://ue1.public.payments.npr.fast.asurion.com/dev";

      case Interfaces_1.Env.local:
        return "http://localhost:3000/v3";

      default:
        return "http://fakeUrl";
    }
  };

  Config.defaultTimeout = 5000;
  Config.defaultVendorTimeout = 15000;
  return Config;
}();

exports.Config = Config;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Configs/config.api.js